import { useCallback } from 'react'
import { useAuthStore } from '@/stores/authStore'

/**
 * Permission checking hook — sync role checks from Zustand.
 *
 * Uses roles synced from the API (via AuthSyncProvider) and stored in Zustand.
 * Both methods return immediately without a promise, making them suitable for
 * UI guards (AuthGuard, conditional rendering).
 */
export const usePermissions = () => {
	const storeHasRole = useAuthStore((s) => s.hasRole)
	const storeHasOrganizationRole = useAuthStore((s) => s.hasOrganizationRole)

	const hasRole = useCallback((role: string): boolean => storeHasRole(role), [storeHasRole])

	const hasOrganizationRole = useCallback(
		(organizationId: string, role: string): boolean => storeHasOrganizationRole(organizationId, role),
		[storeHasOrganizationRole],
	)

	return { hasRole, hasOrganizationRole }
}
